export const INFINITY = 1e48;
export const MAX_INT = 2 ** 32;
export const MAX_LONG = 2 ** 64;
